import { ref, reactive, computed } from 'vue';

import Api from '@/api/Api';

import { useBaseStationsStore } from '@/stores/baseStations';
import { usePaasStore } from '@/stores/paas';

import { showErrorMessage } from '@/components/common/errorMessage';

import { addBaseStationStatusData } from '@/utils/baseStationsUtils';

export function useBaseStationData(baseStationId, setBaseStationLabel) {
	// создает объекты с данными БС
	// возвращает функцию для загрузки данных БС
	const formState = reactive({
		label: '',
		protocol: '',
		protocolSecure: false,
		ant: '',
		allowAntDetection: true,
		includeInNear: true,
		includeInVrs: false,
		dumpCasterInputRawData: false,
		subNetworks: [],

		host: '',
		port: '',
		username: '',
		password: '',

		mntpntInt: '',
		mntpntSrc: '',
		request: '',

		antReferencePoint: '',
		xCoord: '',
		yCoord: '',
		zCoord: '',

		bCoord: null,
		lCoord: null,
		hCoord: null,

		ftpPassword: '',
		info: '',
	});

	const updateFormState = (field, value) => {
		formState[field] = value;
	};

	const baseStationsStore = useBaseStationsStore();
	// данные из store
	const baseStationObj = computed(() => {
		let baseStations = baseStationsStore.items.filter(item => item.id === baseStationId.value);
		return (baseStations.length > 0) ? addBaseStationStatusData(baseStations[0]) : null;
	});

	// TODO: refactor. merge with formData?
	// допданные из запроса при редактировании
	const baseStationDetails = ref({});
	const isLoadingDetails = ref(false);

	const paasStore = usePaasStore();
	const loadBaseStationDetails = () => {
		isLoadingDetails.value = true;
		Api.baseStationGetDetails(baseStationId.value, response => {
			if (response.status === 'ok') {
				const data = Api.deserializeBaseStationDetails(response.base_station);
				baseStationDetails.value = data;
				const editableData = { ...data };
				delete editableData.rtcm1033Info;
				Object.assign(formState, editableData);
				setBaseStationLabel(data.label);
				paasStore.updatePaasData();
			} else {
				showErrorMessage(response.errors);
			}
			isLoadingDetails.value = false;
		});
	}
	return {
		formState,
		baseStationObj,
		baseStationDetails,
		isLoadingDetails,
		updateFormState,
		loadBaseStationDetails,
	}
}
